export default __webpack_public_path__ + "static/media/jolt-100-4.2f2ecfca.jpg";